/**
 * VIS-150: The Dashboard and Analytics surfaces were global, pinned nav items even
 * though their content is entirely Corporate Security. They now live inside the
 * Corporate Security module at `/security/*`.
 *
 * VIS-197: All remaining Security module items (Incidents, Executive Protection,
 * Threat Intelligence, Investigations, Subjects) are also relocated under `/security/*`
 * so every Corporate Security route follows the same `/security/<item>` convention.
 *
 * This module is the single source of truth for the relocation so `App.tsx` (route
 * wiring) and the routing test cannot drift apart.
 */

/** Canonical in-module path for the relocated security dashboard. */
export const SECURITY_DASHBOARD_PATH = '/security/dashboard';
/** Canonical in-module path for the relocated security analytics. */
export const SECURITY_ANALYTICS_PATH = '/security/analytics';
/** Canonical in-module path for the security analytics reports placeholder. */
export const SECURITY_ANALYTICS_REPORTS_PATH = '/security/analytics/reports';

// VIS-197: Security module item paths now nested under /security.
export const SECURITY_INCIDENTS_PATH = '/security/incidents';
export const SECURITY_EXECUTIVE_PROTECTION_PATH = '/security/executive-protection';
export const SECURITY_THREATS_PATH = '/security/threats';
export const SECURITY_INVESTIGATIONS_PATH = '/security/investigations';
export const SECURITY_SUBJECTS_PATH = '/security/subjects';
// VIS-199: Recommended Security Vendor Directory.
export const SECURITY_VENDOR_DIRECTORY_PATH = '/security/vendor-directory';

export interface LegacyRedirect {
  /** Legacy path, relative to the authenticated `/` layout route (no leading slash). */
  readonly from: string;
  /** Absolute relocated path to redirect to. */
  readonly to: string;
}

/**
 * Legacy global paths that must keep working (bookmarks) by redirecting to their
 * relocated in-module path. Order matters: more specific paths first so a parent
 * redirect never shadows a child.
 */
export const LEGACY_REDIRECTS: readonly LegacyRedirect[] = [
  { from: 'analytics/reports', to: SECURITY_ANALYTICS_REPORTS_PATH },
  { from: 'analytics', to: SECURITY_ANALYTICS_PATH },
  { from: 'dashboard', to: SECURITY_DASHBOARD_PATH },
  // VIS-197: old top-level security paths now nest under /security.
  { from: 'incidents', to: SECURITY_INCIDENTS_PATH },
  { from: 'executive-protection', to: SECURITY_EXECUTIVE_PROTECTION_PATH },
  { from: 'threats', to: SECURITY_THREATS_PATH },
  { from: 'investigations', to: SECURITY_INVESTIGATIONS_PATH },
  { from: 'subjects', to: SECURITY_SUBJECTS_PATH },
];
